/* eslint-disable jsx-a11y/anchor-is-valid */

const About = () => {
    return (
        <>
            <section id="about" className="experience-section px-5">
                <div className="container">
                    <div className="row">
                        {/* <!--Left Section --> */}
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="about-left-section">
                                <h6>The Unique Story</h6>
                                <h2>52 Years Of Experience</h2>
                                <span className="line"></span>
                                <div className="story-text">
                                    <div className="story-text-left">
                                        <p className="big-text">Lorem Ipsum is simply dummy text of the printorem Ipsum is simply mmy text of the printing andLorem Ipsum is simply dummy text of the printorem Ipsum is simply the printing and.</p>
                                        <p>Lorem Ipsum is simply dummy text of the printorem Ipsum is simply mmy text of the printing and typing industry Lorem Ipsum has been the industrys stanard dummy text ever since the when an g and ing indrem Ipsumf. the printing and ypeseing ndustry Lorem sum has been the industrysLorem Ipsum is simply dummy text of the printorem Ipsum is simply mmy text of the printin gbeen the industrys.and typing industry Lorem Ipsum has been the industrys standard dummy text ever since the when an g and ing induLorem Ipsumf. the printing and ypeseing ndustry.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- --> */}

                        {/* <!--Right Section --> */}
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="about-right-section">
                                <img src="./assets/images/about-image.png" alt="aboutimage" />
                            </div>
                        </div>
                        {/* <!-- --> */}

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <a href="#" title="read more" className="read-more-btn">read more</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About